export const CHECKBOX = {
  SHAPE: { CIRCLE: "circle", DEFAULT: "default" },
};